"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteCustomerModal = void 0;
const react_1 = __importDefault(require("react"));
const client_1 = require("@apollo/client");
const react_error_boundary_1 = require("react-error-boundary");
const polaris_1 = require("@shopify/polaris");
const AccountContext_1 = require("contexts/AccountContext");
const utils_1 = require("components/Dashboard/OrderDetails/utils");
const graphql_1 = require("./graphql");
const DeleteCustomerModal = ({ active, selectedCustomer, onClose, onSuccess }) => {
    const handleError = (0, react_error_boundary_1.useErrorHandler)();
    const { account } = (0, AccountContext_1.useAccount)();
    const [deleteCustomer, { error }] = (0, client_1.useMutation)(graphql_1.DELETE_CUSTOMER, {
        refetchQueries: [
            { query: graphql_1.GET_CUSTOMERS, variables: { accountId: account === null || account === void 0 ? void 0 : account.id } },
            'customers'
        ],
        onCompleted: () => {
            onSuccess();
        }
    });
    if (error) {
        handleError(error);
    }
    return (react_1.default.createElement(polaris_1.Modal, { onClose: onClose, open: active, primaryAction: {
            content: 'Delete customer',
            destructive: true,
            onAction: () => {
                if (!selectedCustomer) {
                    throw new Error('No customer selected');
                }
                if (!account) {
                    throw new Error('No account selected');
                }
                deleteCustomer({
                    variables: {
                        input: { id: selectedCustomer.id, accountId: account.id }
                    }
                });
            }
        }, secondaryActions: [
            {
                content: 'Cancel',
                onAction: onClose
            }
        ], title: `Delete Customer (${(0, utils_1.formatCustomerName)(selectedCustomer)})` },
        react_1.default.createElement(polaris_1.Modal.Section, null,
            react_1.default.createElement(polaris_1.Text, { as: 'p' }, "This can't be undone. All orders placed by this customer will be deleted as well. The customer will be deleted from your Malomo account, but not in Shopify."))));
};
exports.DeleteCustomerModal = DeleteCustomerModal;
